import { gameLayers } from "game-layers";
import { CelebrateWinComponent } from "slotworks/components/celebrate-win/celebrate-win-component";
import { ApplyFowlPlayTextStyling } from "util/fowl-text-style";

export class FowlCelebrateWinComponent extends CelebrateWinComponent {
    public init(): void {
        super.init();
        // gameLayers.CelebrationContent.onSceneEnter.add((scene: string) => {
        //     if (scene.includes("line_row")) {
        //         const value = gameLayers.CelebrationContent.getText("value");
        //         ApplyFowlPlayTextStyling(value, 2);
        //     }
        // });
    }
}
